import styles from './ChatBubble.module.css'

interface ChatBubbleProps {
  title: string
  description: string
  isVisible: boolean
  side: 'left' | 'right'
  borderColor: string
  targetPosition: { x: number; y: number }
  bubblePosition: { x: number; y: number }
}

export function ChatBubble({
  title,
  description,
  isVisible,
  side,
  borderColor,
  targetPosition,
  bubblePosition,
}: ChatBubbleProps) {
  const arrowPath =
    side === 'left'
      ? `M ${bubblePosition.x + 20} ${bubblePosition.y + 30} Q ${(bubblePosition.x + targetPosition.x) / 2} ${bubblePosition.y - 50} ${targetPosition.x} ${targetPosition.y}`
      : `M ${bubblePosition.x - 20} ${bubblePosition.y + 30} Q ${(bubblePosition.x + targetPosition.x) / 2} ${bubblePosition.y - 50} ${targetPosition.x} ${targetPosition.y}`

  return (
    <div
      className={`${styles.chatBubbleContainer} ${isVisible ? styles.visible : ''}`}
      style={{ left: bubblePosition.x, top: bubblePosition.y }}
    >
      {isVisible && (
        <svg
          className={styles.curvedArrow}
          aria-hidden="true"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            pointerEvents: 'none',
            zIndex: 1,
            opacity: isVisible ? 0.5 : 0,
            transition: 'opacity 2s ease-in-out',
          }}
        >
          <path
            d={arrowPath}
            stroke={borderColor}
            strokeWidth="1.5"
            fill="none"
            strokeOpacity="0.4"
            strokeDasharray="3,6"
          />
          <circle
            cx={targetPosition.x}
            cy={targetPosition.y}
            r="3"
            fill={borderColor}
            fillOpacity="0.6"
          />
        </svg>
      )}

      <div
        className={`${styles.chatBubble} ${styles[side]}`}
        style={{
          borderColor,
          boxShadow: `0 0 20px ${borderColor}40`,
        }}
      >
        <div className={styles.bubbleContent}>
          <h3 className={styles.title}>&ldquo;{title}&rdquo;</h3>
          <p className={styles.description}>{description}</p>
        </div>
        <div
          className={`${styles.bubblePointer} ${styles[side]}`}
          style={{ borderTopColor: borderColor }}
        />
      </div>
    </div>
  )
}
